import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { FireBaseProvider } from './context/firebase'
import { MobXProvider } from './context/mobx'
import { Navigation } from './components/navigation'

function App() {
  return (
    <MobXProvider>
      <FireBaseProvider>
        <BrowserRouter>
          <div className='App'>
            <Navigation />
          </div>
        </BrowserRouter>
      </FireBaseProvider>
    </MobXProvider>
  )
}

export default App
